import { render } from "./ComplianceHome.vue?vue&type=template&id=b12c0264&scoped=true"
import script from "./ComplianceHome.vue?vue&type=script&lang=js"
export * from "./ComplianceHome.vue?vue&type=script&lang=js"

import "./ComplianceHome.vue?vue&type=style&index=0&id=b12c0264&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b12c0264"]])

export default __exports__